import ProductCardSkeleton from '@/components/common/Skeleton/new-product-card';

const ContentFeedSkeletonV2 = ({
  viewRef,
  cmsComponentKey = 'cm_content_feed'
}: {
  viewRef?: React.RefObject<HTMLDivElement>;
  cmsComponentKey?: string;
}) => {
  return (
    <div className="bg-surface-100-bg my-2.5 px-1.5" ref={viewRef} data-module={cmsComponentKey}>
      <div className="flex whitespace-nowrap overflow-hidden flex-wrap">
        {Array.from({ length: 9 })
          .fill(0)
          .map((_item, index) => {
            return (
              <ProductCardSkeleton key={`skeleton-product-list-item-${index}`} className="w-1/3 box-border p-0.5" />
            );
          })}
      </div>
    </div>
  );
};

export default ContentFeedSkeletonV2;
